(() => {
  const key = 'comparison';
  const controllers = new Map();
  const destroy = (id) => { controllers.get(id)?.abort(); controllers.delete(id); };
  const init = (scope = document) => {
    scope.querySelectorAll('[data-menoplay-pdp-module="comparison"]').forEach((root) => {
      const id = root.dataset.sectionId || key;
      destroy(id);
      const controller = new AbortController();
      controllers.set(id, controller);
      const on = (target, type, listener, options = {}) => target?.addEventListener(type, listener, { ...options, signal: controller.signal });
      const nativeAdd = EventTarget.prototype.addEventListener;
      EventTarget.prototype.addEventListener = function(type, listener, options = {}) {
        const normalized = typeof options === 'boolean' ? { capture: options } : { ...options };
        if (!normalized.signal) normalized.signal = controller.signal;
        return nativeAdd.call(this, type, listener, normalized);
      };
      try { ((root, on) => { root.querySelectorAll('[data-open-evidence-modal]').forEach((trigger) => on(trigger, 'click', () => window.MenoPlayPDP?.openEvidence(trigger))); })(root, on, controller.signal); } finally { EventTarget.prototype.addEventListener = nativeAdd; }
    });
  };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target.querySelector('[data-section-id]')?.dataset.sectionId));
  init();
})();
